import * as React from "react";

function Preview() {
  return (
    <svg
      width="138"
      height="42"
      viewBox="0 0 138 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.052124 0V7.14734L14.3657 11.7743L25.4563 8.20063V8.18182L0.052124 0Z"
        fill="#8BD3E6"
      />
      <path
        d="M0.052124 9.23535V16.3827L11.1617 12.809L0.052124 9.23535Z"
        fill="#8BD3E6"
      />
      <path
        d="M14.3657 20.991L25.4563 17.4173L22.2524 16.3828L11.1617 19.9565L14.3657 20.991Z"
        fill="#8BD3E6"
      />
      <path
        d="M14.3657 30.2253L25.4563 26.6517L22.2524 25.6172L11.1617 29.1909L14.3657 30.2253Z"
        fill="#8BD3E6"
      />
      <path
        d="M7.93879 20.9912L0.052124 23.5492V25.6182L11.1617 22.0445L7.93879 20.9912Z"
        fill="#8BD3E6"
      />
      <path
        d="M0.052124 25.6172V32.7645L11.1617 29.1909L0.052124 25.6172Z"
        fill="#343741"
      />
      <path
        d="M11.1617 22.0445L22.2524 25.6182L25.4563 24.5837V24.5649L14.3657 20.9912L11.1617 22.0445Z"
        fill="#343741"
      />
      <path
        d="M25.4563 24.5643V17.417L14.3657 20.9907L25.4563 24.5643Z"
        fill="#0084D4"
      />
      <path
        d="M0.052124 25.6176L11.1617 29.1913L22.2523 25.6176L11.1617 22.0439L0.052124 25.6176Z"
        fill="#0084D4"
      />
      <path
        d="M0.052124 34.8337V41.9999L25.4563 33.7993L14.3657 30.2256L0.052124 34.8337Z"
        fill="#343741"
      />
      <path
        d="M25.4563 33.7997V26.6523L14.3657 30.226L25.4563 33.7997Z"
        fill="#0084D4"
      />
      <path
        d="M11.1617 12.8089L22.2524 16.3826L25.4563 15.3481L14.3657 11.7744L11.1617 12.8089Z"
        fill="#343741"
      />
      <path
        d="M11.1617 19.9565L0.052124 16.3828V18.4518L7.93879 20.991L11.1617 19.9565Z"
        fill="#343741"
      />
      <path
        d="M25.4563 15.3485V8.20117L14.3657 11.7748L25.4563 15.3485Z"
        fill="#0084D4"
      />
      <path
        d="M0.052124 16.3832L11.1617 19.9569L22.2523 16.3832L11.1617 12.8096L0.052124 16.3832Z"
        fill="#0084D4"
      />
      <path
        d="M0.052124 18.4521V23.5493L7.93879 20.9913L0.052124 18.4521Z"
        fill="#0084D4"
      />
      <path
        d="M33.6841 26.5018V15.7432H39.9972V17.4924H35.7505V20.0128H39.4474L39.0872 21.7808H35.7505V24.7526H39.9972V26.5018H33.6841Z"
        fill="#0084D4"
      />
      <path
        d="M51.3723 26.5018L46.2725 19.0911V26.5018H44.3387V15.7432H46.3104L51.1637 22.7776V15.7432H53.0975V26.5018H51.3723Z"
        fill="#0084D4"
      />
      <path
        d="M62.8042 26.5387H60.7567L56.6617 15.6484H58.9747L61.8563 23.8679L64.7001 15.7425H66.8803L62.8042 26.5387Z"
        fill="#0084D4"
      />
      <path
        d="M85.0991 26.6146C83.9237 26.6334 82.7483 26.3701 81.6866 25.881L82.0089 24.0001C82.9189 24.5268 84.0564 24.9406 85.1371 24.9406C86.1039 24.9406 86.7485 24.4892 86.7485 23.624C86.7485 22.834 86.3694 22.4954 84.7958 21.8371C82.6914 20.9719 81.8383 20.2948 81.8383 18.6208C81.8383 16.7212 83.3171 15.6114 85.3456 15.6114C86.3314 15.5926 87.3173 15.8183 88.2083 16.2697L87.905 18.1318C87.1466 17.624 86.2556 17.323 85.3456 17.2854C84.3029 17.2854 83.8479 17.7933 83.8479 18.4328C83.8479 19.1099 84.1891 19.4484 85.7058 20.0691C87.9429 20.9719 88.7581 21.7431 88.7581 23.3983C88.7392 25.5237 87.1846 26.6146 85.0991 26.6146Z"
        fill="#0084D4"
      />
      <path
        d="M97.4411 17.53V26.5018H95.3368V17.53H92.1328V15.7432H100.74L100.342 17.53H97.4411Z"
        fill="#0084D4"
      />
      <path
        d="M111.546 26.5018L106.446 19.0911V26.5018H104.512V15.7432H106.484L111.337 22.7776V15.7432H113.271V26.5018H111.546Z"
        fill="#0084D4"
      />
      <path
        d="M133.116 17.53V26.5018H131.031V17.53H127.808V15.7432H136.32L135.922 17.53H133.116Z"
        fill="#0084D4"
      />
      <path
        d="M70.8615 26.4644V15.7246H77.1556V17.4738H72.9279V19.9942H76.6248L76.2646 21.7622H72.9279V24.734H77.1746V26.4644H70.8615Z"
        fill="#0084D4"
      />
      <path
        d="M118.105 26.5018V15.7432H124.4V17.4924H120.153V20.0128H123.85L123.49 21.7996H120.153V24.7526H124.419V26.5018H118.105Z"
        fill="#0084D4"
      />
      <path
        d="M64.3292 38.7691H63.4674V32.4033H64.3292V38.7691Z"
        fill="black"
        fillOpacity="0.85"
      />
      <path
        d="M76.3954 35.5885C76.3954 36.0653 76.3198 36.4991 76.1688 36.8901C76.0178 37.281 75.8045 37.6156 75.5291 37.894C75.2537 38.1724 74.9235 38.3886 74.5385 38.5426C74.1535 38.6936 73.727 38.7691 73.2591 38.7691H70.878V32.4033H73.2591C73.727 32.4033 74.1535 32.4803 74.5385 32.6343C74.9235 32.7854 75.2537 33.0016 75.5291 33.2829C75.8045 33.5613 76.0178 33.8959 76.1688 34.2869C76.3198 34.6778 76.3954 35.1116 76.3954 35.5885ZM75.5113 35.5885C75.5113 35.1975 75.458 34.8481 75.3514 34.5401C75.2448 34.2321 75.0938 33.9715 74.8983 33.7582C74.7028 33.545 74.4659 33.3821 74.1875 33.2696C73.9092 33.157 73.5997 33.1008 73.2591 33.1008H71.7443V38.0717H73.2591C73.5997 38.0717 73.9092 38.0154 74.1875 37.9029C74.4659 37.7904 74.7028 37.629 74.8983 37.4187C75.0938 37.2055 75.2448 36.9448 75.3514 36.6368C75.458 36.3288 75.5113 35.9794 75.5113 35.5885Z"
        fill="black"
        fillOpacity="0.85"
      />
      <path
        d="M86.3362 32.4033V33.1052H83.2799V35.2197H85.7543V35.895H83.2799V38.0673H86.3362V38.7691H82.4137V32.4033H86.3362Z"
        fill="black"
        fillOpacity="0.85"
      />
      <path
        d="M92.8665 32.4033C92.9435 32.4033 92.9998 32.4137 93.0353 32.4344C93.0738 32.4522 93.1167 32.4907 93.1641 32.5499L96.8512 37.3476C96.8424 37.2706 96.8364 37.1966 96.8335 37.1255C96.8305 37.0515 96.829 36.9804 96.829 36.9123V32.4033H97.5842V38.7691H97.1489C97.0808 38.7691 97.023 38.7573 96.9756 38.7336C96.9312 38.7099 96.8868 38.6699 96.8424 38.6137L93.1597 33.8204C93.1656 33.8945 93.1701 33.967 93.173 34.0381C93.176 34.1092 93.1775 34.1743 93.1775 34.2336V38.7691H92.4223V32.4033H92.8665Z"
        fill="black"
        fillOpacity="0.85"
      />
      <path
        d="M108.32 32.4033V33.1274H106.263V38.7691H105.401V33.1274H103.335V32.4033H108.32Z"
        fill="black"
        fillOpacity="0.85"
      />
      <path
        d="M115.092 38.7691H114.231V32.4033H115.092V38.7691Z"
        fill="black"
        fillOpacity="0.85"
      />
      <path
        d="M125.977 32.4033V33.1274H123.92V38.7691H123.058V33.1274H120.993V32.4033H125.977Z"
        fill="black"
        fillOpacity="0.85"
      />
      <path
        d="M134.18 36.237V38.7691H133.323V36.237L130.99 32.4033H131.746C131.823 32.4033 131.883 32.4226 131.928 32.4611C131.972 32.4996 132.011 32.547 132.043 32.6032L133.5 35.0776C133.56 35.1812 133.608 35.279 133.647 35.3708C133.688 35.4626 133.725 35.5529 133.758 35.6418C133.791 35.55 133.826 35.4581 133.865 35.3663C133.903 35.2745 133.952 35.1783 134.011 35.0776L135.464 32.6032C135.49 32.5558 135.526 32.5114 135.57 32.47C135.618 32.4255 135.679 32.4033 135.753 32.4033H136.517L134.18 36.237Z"
        fill="black"
        fillOpacity="0.85"
      />
    </svg>
  );
}

export default Preview;
